import ListDropdown from '@/components/list-dropdown';
import { newWMSTileLayer, defaultInteractions } from "@/components/ol-map/helpers";
import { loadingClass } from '@/lib/helpers';
import BeanCoord from '@/lib/models/bean-coord';
import ComCommune from '@/lib/models/com-commune';
import ComSystProjectFrance from '@/lib/models/com-syst-project-france';
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from 'vuex-class';

@Component
export default class LocMapMixin extends Vue {

  @Getter getLexique;

  protected overedCoordinates: BeanCoord = null;
  protected overedFeatures: any[] = [];
  protected selectedCoordinates: BeanCoord = null;
  protected preferedEpsg: string = "epsg:4326";
  protected zoom: number = 10;
  protected loading: number = 0;

  @Prop({required: false, type: String}) readonly numCavite!: string;
  @Prop({required: false, type: Object}) readonly commune!: ComCommune;
  @Prop({required: false, default: () => null}) readonly cavCoords!: BeanCoord;

  created() {
    this.selectedCoordinates = this.cavCoords;
    if (this.selectedCoordinates) {
      this.preferedEpsg = this.selectedCoordinates.epsg;
    }
    if (this.providedCenter) {
      this.zoom = 14;
    }
  }

  get layers() {
    return [
      ...(window as any).rootConfig.MAP.LAYERS.map(pl => newWMSTileLayer(pl))
    ];
  }

  get providedCenter() {
    if (this.selectedCoordinates) {
      return this.selectedCoordinates.asWgs84().asArray();
    } else if (this.commune) {
      return [this.commune.longi, this.commune.lat];
    }
    return null;
  }

  get displayedCoordinatesPrecision() {
    return this.preferedEpsg.toLowerCase() === "epsg:4326" ? 6 : 0;
  }

  get mapDefaultInteractions() {
    return defaultInteractions();
  }

  async mounted() {}

  renderOveredCoordinates() {
    return (
      <div class="map-coords is-airy is-flex justify-space-between">
        <div class="is-flex">
          {this.overedCoordinates && [
            <ListDropdown class="basic"
              nullable={false}
              vModel={this.preferedEpsg}
              data={this.getLexique(ComSystProjectFrance)}
              labelFn={v => v.systemeProjection}
              transform={v => v.epsg.toLowerCase()}
              prompt="-"/>,
            <div>
              {
                this.overedCoordinates.project(this.preferedEpsg)
                  .asArray()
                  .map(c => c.toFixed(this.displayedCoordinatesPrecision))
                  .join(" / ")
              }
            </div>
          ]}
        </div>
        {this.renderOveredFeatureInfo()}
        <div class={`map-loader async ${loadingClass(this.loading)}`}></div>
      </div>
    );
  }

  renderOveredFeatureInfo() {
    return null;
  }

}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-d704fb32/loc-map.tsx" });